import { render, staticRenderFns } from "./WeekScheduler.vue?vue&type=template&id=489986a4&scoped=true&"
import script from "./WeekScheduler.vue?vue&type=script&lang=js&"
export * from "./WeekScheduler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489986a4",
  null
  
)

export default component.exports